import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { CourseTemplateService } from 'app/core/services/course-template.service';
import { CourseTemplate } from 'app/shared/models/course-template';

@Injectable()
export class CourseTemplatesResolver implements Resolve<CourseTemplate[]> {
  constructor(private courseTemplateService: CourseTemplateService, private router: Router) {}

  resolve(): Promise<any> {
    return this.courseTemplateService.getCourseTemplates().catch(error => {
      this.router.navigate(['/error']);
      return Promise.reject(error);
    });
  }
}
